import styled from 'styled-components';

const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  flex-shrink: 0;
  flex: 1 0 auto;
`;

export { Layout };
